import React from 'react'
import '../../styles/designs/FeatureCard.css'

import TextField from '../text/TextField';
import TitleField from '../text/TitleField';

const FeatureCard = ({ title, description, icon: Icon, orientation, descriptionFontSize = '0.9rem' }) => {

    const variant = orientation === 'landscape' ? 'landscape' : 'portrait';

    return (
        <>
            <div className={`feature-card-container feature-card-container--${variant}`}>
                <div className={`feature-card-icon-container feature-card-icon-container--${variant}`}>
                    {Icon ? <Icon className={`feature-card-icon feature-card-icon--${variant}`} /> : null}
                </div>

                <div className={`feature-card-text-block feature-card-text-block--${variant}`}>
                    <div className={`feature-card-title-container feature-card-title-container--${variant}`}>
                        <TitleField title={title} level={3} bold={true} />
                    </div>
                    <div className={`feature-card-description-container feature-card-description-container--${variant}`}>
                        <TextField text={description} fontColor="#666666" fontSize={descriptionFontSize} />
                    </div>
                </div>
            </div>
        </>
    );

};


export default FeatureCard;
